/* Base translations · W17 worksheets — moved unchanged out of lib/i18n.js (STEP 2 · B2).
   Top-level keys owned by this file (no other base file and not i18n.js define them): w17_1, w17_2, w17_5, w17_6, w17_7Misstatement, w17_7Auto. */
export const I18N_BASE_W17 = {
  en: {
    // Batch E · Round E1 — Review engagement dictionary (W17.1 / W17.2 / grey-not-hide)
    w17_1: {
      title: "Acceptance, preconditions and terms",
      subtitle: "ISRE 2400 (Revised); partner responsibilities.",
      preconditions: "Preconditions for a review engagement",
      pre: {
        rational_purpose: "The engagement has a rational purpose.",
        framework_acceptable: "The financial-reporting framework is acceptable.",
        mgmt_acknowledges_responsibilities: "Management acknowledges its responsibilities for the financial statements and for making information available.",
        ethics_independence_met: "Ethics and independence requirements are met.",
        information_expected_available: "The information the practitioner expects is available.",
        no_scope_limitation: "No management-imposed scope limitation is present.",
      },
      metBy: "Confirmed by {name} · {date}",
      acceptanceOk: "All six preconditions are met. Acceptance may proceed.",
      acceptanceBlocked: "Acceptance is blocked until all six preconditions are met.",
      signOff: "Partner sign-off",
      signDatePh: "Sign date",
      signBtn: "Sign off (Partner)",
      signBlocked: "Complete all six preconditions before Partner sign-off.",
      signedBy: "Signed off by {name} · {date}",
      signedOk: "W17.1 signed off.",
      notForAudit: "This page belongs to a Review engagement (ISRE 2400 Revised).",
      termsTitle: "Terms agreed",
      termsAgreedAt: "Terms agreed on",
      termsLetterLink: "Engagement letter",
      termsSaveOk: "Terms and engagement-letter link saved.",
      termsDatePh: "Date",
      termsSaveBtn: "Save",
    },
    w17_2: {
      title: "Understanding the entity",
      subtitle: "ISRE 2400 (Revised).",
      areasTitle: "Understanding areas",
      areas: {
        entity_and_environment: "Entity and environment",
        entity_and_environment_ph: "Ownership, governance, operations, financing…",
        industry_regulatory: "Industry and regulatory factors",
        industry_regulatory_ph: "Regulator, market, applicable law…",
        accounting_systems_records: "Accounting systems and records",
        accounting_systems_records_ph: "ERP, journals, controls over recording, close cycle…",
        framework_and_policies: "Framework and accounting policies",
        framework_and_policies_ph: "Applied framework, significant policies, changes…",
      },
      save: "Save",
      savedOk: "Understanding saved.",
      likelyTitle: "Areas where material misstatements are likely",
      likelyPh: "e.g. Trade receivables — collectability at year-end",
      add: "Add",
      likelyAreaInvalid: "Please type an area before adding.",
      noLikelyAreas: "No likely-misstatement areas listed yet.",
      notForAudit: "This page belongs to a Review engagement (ISRE 2400 Revised).",
    },
    w17_5: {
      title: "Specific circumstances",
      subtitle: "ISRE 2400 (Revised).",
      relatedParties: "Related parties",
      linkW16: "Open W16 — Related parties",
      relatedPartiesPh: "Summary of related-party procedures on this review.",
      fraudNoncompliance: "Fraud / non-compliance indicators, communication, effect",
      fraud_indicatorsPh: "Fraud indicators identified",
      fraud_communicationPh: "Communication (management, TCWG, regulator)",
      fraud_effectPh: "Effect on the review conclusion",
      noncompliance_indicatorsPh: "Non-compliance indicators identified",
      noncompliance_communicationPh: "Communication of non-compliance",
      goingConcern: "Going concern",
      linkGc: "Open 209(a) — Going Concern (review wording)",
      going_concern_summaryPh: "Summary of going concern conclusion (review wording).",
      going_concern_reference_209aPh: "Reference to 209(a) working paper",
      otherPractitioners: "Other practitioners / experts (W17.5)",
      other_practitioners_usedPh: "Other practitioners used (Y/N/details)",
      other_practitioners_notesPh: "Notes on the work of other practitioners",
      experts_usedPh: "Experts used (Y/N/details)",
      experts_notesPh: "Notes on the work of experts",
      save: "Save",
      saved: "W17.5 saved.",
      notForAudit: "This page belongs to a Review engagement (ISRE 2400 Revised).",
    },
    w17_6: {
      title: "Reconciliation to accounting records",
      subtitle: "ISRE 2400 (Revised) — TB → FS by FS head.",
      rowsTitle: "TB → FS by FS head",
      runBtn: "Recompute",
      runQueued: "Reconciliation recompute queued.",
      fsHead: "FS head",
      tbAmount: "TB amount",
      fsAmount: "FS amount",
      difference: "Difference",
      explanation: "Explanation",
      reviewerConclusion: "Practitioner's conclusion",
      conclusionPh: "Practitioner's overall conclusion on TB → FS reconciliation",
      concludeBtn: "Save conclusion",
      concluded: "Reconciliation conclusion saved.",
      signedBy: "Signed by {name} · {date}",
      notForAudit: "This page belongs to a Review engagement (ISRE 2400 Revised).",
    },
    // K5 — misstatement amount + type on the W17.7 register.
    w17_7Misstatement: {
      amountLabel: "Misstatement amount",
      typeLabel: "Misstatement type",
      typeFactual: "Factual",
      typeJudgmental: "Judgmental",
      typeProjected: "Projected",
      requireBeforeSend: "Enter the amount and pick a type before setting outcome to Materially misstated (no zero-amount W9 rows).",
      pickType: "— type —",
    },
    w17_7Auto: {
      analyticalDiff: "Analytical difference {diff} exceeds threshold {threshold} on {fsHead}.",
      inquiryFollowup: "Follow-up on required inquiry: {topic}",
      notSpecific: "Not specific to one FS head",
    },
  },
  ar: {
    w17_1: {
      title: "القبول والشروط المسبقة وشروط الارتباط",
      subtitle: "المعيار الدولي لارتباطات الفحص \u2066ISRE 2400\u2069 (المُنقّح)؛ ومسؤوليات الشريك.",
      preconditions: "الشروط المسبقة لارتباط الفحص",
      pre: {
        rational_purpose: "للارتباط غرض منطقي.",
        framework_acceptable: "إطار التقرير المالي المستخدم مقبول.",
        mgmt_acknowledges_responsibilities:
          "تُقرّ الإدارة بمسؤولياتها عن القوائم المالية وعن إتاحة المعلومات.",
        ethics_independence_met: "مُستوفاة متطلبات السلوك المهني والاستقلالية.",
        information_expected_available:
          "المعلومات التي يتوقعها الممارس ستكون متاحة.",
        no_scope_limitation: "لا يوجد قيد على النطاق مفروض من الإدارة.",
      },
      metBy: "أكّده \u2066{name}\u2069 · {date}",
      acceptanceOk: "استُوفيت الشروط المسبقة الستة. يمكن استكمال القبول.",
      acceptanceBlocked: "القبول محجوب إلى حين استيفاء الشروط المسبقة الستة.",
      signOff: "توقيع الشريك",
      signDatePh: "تاريخ التوقيع",
      signBtn: "توقيع (الشريك)",
      signBlocked: "أكمل الشروط المسبقة الستة قبل توقيع الشريك.",
      signedBy: "وقّعه \u2066{name}\u2069 · {date}",
      signedOk: "تم توقيع \u2066W17.1\u2069.",
      notForAudit: "هذه الصفحة تخصّ ارتباط الفحص (\u2066ISRE 2400\u2069 المُنقّح).",
      termsTitle: "شروط الارتباط",
      termsAgreedAt: "تاريخ الاتفاق على الشروط",
      termsLetterLink: "رسالة الارتباط",
      termsSaveOk: "تم حفظ الشروط وربطها برسالة الارتباط.",
      termsDatePh: "التاريخ",
      termsSaveBtn: "حفظ",
    },
    w17_2: {
      title: "فهم المنشأة",
      subtitle: "المعيار الدولي لارتباطات الفحص \u2066ISRE 2400\u2069 (المُنقّح).",
      areasTitle: "مجالات الفهم",
      areas: {
        entity_and_environment: "المنشأة وبيئتها",
        entity_and_environment_ph: "الملكية والحوكمة والعمليات والتمويل…",
        industry_regulatory: "عوامل القطاع والتنظيم",
        industry_regulatory_ph: "الجهة التنظيمية والسوق والقانون المطبَّق…",
        accounting_systems_records: "الأنظمة والسجلات المحاسبية",
        accounting_systems_records_ph: "نظام المحاسبة، دفاتر اليومية، ضوابط التسجيل…",
        framework_and_policies: "الإطار والسياسات المحاسبية",
        framework_and_policies_ph: "الإطار المطبَّق، السياسات المهمة، التغييرات…",
      },
      save: "حفظ",
      savedOk: "تم حفظ الفهم.",
      likelyTitle: "المجالات التي يُرجَّح فيها وجود تحريفات جوهرية",
      likelyPh: "مثال: الذمم المدينة — قابلية التحصيل في نهاية السنة",
      add: "إضافة",
      likelyAreaInvalid: "الرجاء كتابة المجال قبل الإضافة.",
      noLikelyAreas: "لا توجد بعد مجالات مسجَّلة.",
      notForAudit: "هذه الصفحة تخصّ ارتباط الفحص (\u2066ISRE 2400\u2069 المُنقّح).",
    },
    w17_5: {
      title: "الظروف الخاصة",
      subtitle: "المعيار الدولي لارتباطات الفحص \u2066ISRE 2400\u2069 (المُنقّح).",
      relatedParties: "الأطراف ذوو العلاقة",
      linkW16: "فتح \u2066W16\u2069 — الأطراف ذوو العلاقة",
      relatedPartiesPh: "ملخص إجراءات الأطراف ذوي العلاقة في هذا الفحص.",
      fraudNoncompliance: "مؤشرات الاحتيال / عدم الالتزام، الإبلاغ، الأثر",
      fraud_indicatorsPh: "مؤشرات الاحتيال المُحدَّدة",
      fraud_communicationPh: "الإبلاغ (الإدارة، المكلفون بالحوكمة، الجهة التنظيمية)",
      fraud_effectPh: "الأثر على خلاصة الفحص",
      noncompliance_indicatorsPh: "مؤشرات عدم الالتزام المُحدَّدة",
      noncompliance_communicationPh: "الإبلاغ عن عدم الالتزام",
      goingConcern: "الاستمرارية",
      linkGc: "فتح \u2066209(a)\u2069 — الاستمرارية (صياغة الفحص)",
      going_concern_summaryPh: "ملخص خلاصة الاستمرارية (صياغة الفحص).",
      going_concern_reference_209aPh: "مرجع ورقة عمل \u2066209(a)\u2069",
      otherPractitioners: "ممارسون / خبراء آخرون (\u2066W17.5\u2069)",
      other_practitioners_usedPh: "الاستعانة بممارسين آخرين (نعم/لا/تفاصيل)",
      other_practitioners_notesPh: "ملاحظات على أعمال الممارسين الآخرين",
      experts_usedPh: "الاستعانة بخبراء (نعم/لا/تفاصيل)",
      experts_notesPh: "ملاحظات على أعمال الخبراء",
      save: "حفظ",
      saved: "تم حفظ \u2066W17.5\u2069.",
      notForAudit: "هذه الصفحة تخصّ ارتباط الفحص (\u2066ISRE 2400\u2069 المُنقّح).",
    },
    w17_6: {
      title: "المطابقة مع السجلات المحاسبية",
      subtitle: "المعيار الدولي لارتباطات الفحص \u2066ISRE 2400\u2069 (المُنقّح) — ميزان المراجعة \u2192 القوائم حسب البند.",
      rowsTitle: "ميزان المراجعة \u2192 القوائم حسب البند",
      runBtn: "إعادة الحساب",
      runQueued: "تمت إضافة إعادة الحساب إلى الطابور.",
      fsHead: "البند",
      tbAmount: "قيمة ميزان المراجعة",
      fsAmount: "قيمة القوائم",
      difference: "الفرق",
      explanation: "التفسير",
      reviewerConclusion: "استنتاج الممارس",
      conclusionPh: "الاستنتاج العام للممارس بشأن المطابقة",
      concludeBtn: "حفظ الاستنتاج",
      concluded: "تم حفظ الاستنتاج.",
      signedBy: "وقّعه \u2066{name}\u2069 · {date}",
      notForAudit: "هذه الصفحة تخصّ ارتباط الفحص (\u2066ISRE 2400\u2069 المُنقّح).",
    },
    // M4 — mtype alignment with W9.
    w17_7Misstatement: {
      amountLabel: "قيمة التحريف",
      typeLabel: "نوع التحريف",
      typeFactual: "فعلي",
      typeJudgmental: "حُكمي",
      typeProjected: "متوقَّع",
      requireBeforeSend: "أدخل قيمة التحريف واختر النوع قبل ضبط النتيجة على «محرَّف جوهريًا» (لا يُرسَل صف بقيمة صفر إلى \u2066W9\u2069).",
      pickType: "— النوع —",
    },
    w17_7Auto: {
      analyticalDiff: "فرق تحليلي {diff} يتجاوز العتبة {threshold} على \u2066{fsHead}\u2069.",
      inquiryFollowup: "متابعة الاستفسار المطلوب: {topic}",
      notSpecific: "غير مرتبط ببند محدد",
    },
  },
};

export default I18N_BASE_W17;
